/**
 * 微信js-sdk说明文档
 * https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/JS-SDK.html#1
 */
import {
  useUserServer,
  useRoomBaseServer,
  setRequestHeaders,
  useInviteServer
} from 'middle-domain';
import {
  isWechat,
  removeUrlParameter,
  replaceHtml,
  isWechatCom,
  getUrlQueryParams,
  removeUrlParamsAndUpdate
} from './tool';
import { $unifiedMessage } from './unifiedMessage';
import qs from 'querystringify';
import { getBrowserType } from '@/app-shared/utils/getBrowserType.js';
import { saveAndSyncBothStorage } from '@vhcl/saas-login';
import { filterAddressParams, buildLoginAddress } from './bizTools';
import { vhSiteBaseInfoHandle } from '@/app-shared/utils/vhSiteBaseInfo';
import { fetchInviteCode } from './bizInvite.js';
import { DEFAULT_SHARE_IMAGE } from '@/app-shared/utils/systemResources.js';
import tojs from 'await-to-js';

/**
 *  统一构建支付当前的授权地址
 * @param {*} to
 * @returns
 */
export function buildPayUrl(to) {
  //获取地址栏参数、设置请求路径
  let _search = '';
  if (location.search && location.search != '') {
    _search = location.search.split('?')[1];
  }
  const address =
    window.location.origin +
    process.env.VUE_APP_WEB_KEY +
    `${to.path}?purpose=payAuth${_search ? '&' + _search : ''}`;
  return address;
}

/**
 * 授权三方登录
 * @param {*} _next 路由函数
 */
export function handleThirdLoginOrPay(_next) {
  const path = window.location.pathname; // 举例： '/v3/lives/watch/671680195'
  const { user_auth_key, purpose, open_id } = getUrlQueryParams([
    'user_auth_key',
    'purpose',
    'open_id'
  ]);
  if (purpose == 'login' && user_auth_key) {
    // 第三方登录后回调
    const params = {
      source: 2, // 1 控制台 2观看端 3admin
      key: user_auth_key,
      scene_id: 1 // 场景id：1登录 2提现绑定 3账户信息-账号绑定
    };
    if (open_id) {
      sessionStorage.setItem('open_id', open_id);
      sessionStorage.setItem('user_auth_key', user_auth_key);
      // unionid 不能为会话缓存
      localStorage.setItem('unionid', user_auth_key);
      console.log('weixin_auth++++++++++++++++++++++++++', 111);
    }
    handleAuth(params, path, _next);
  } else if (purpose == 'payAuth') {
    // 微信授权关闭后，支付走微信授权流程，不需要登录，避免用户信息覆写
    if (open_id) {
      sessionStorage.setItem('open_id', open_id);
      sessionStorage.setItem('user_auth_key', user_auth_key);
    }
    filterAddressParams(path);
  }
}

/**
 * 第三方授权
 * @param {*} params
 * @param {*} path
 * @param {*} _next
 */
export function handleAuth(params, path, _next) {
  console.log('wechat handleAuth------->', _next);
  useUserServer()
    .oauthCallback(params)
    .then(res => {
      if (res && res.code == 200) {
        localStorage.setItem('token', res.data.token || '');
        localStorage.setItem('token_stamp', new Date().getTime());
        localStorage.setItem('userInfo', JSON.stringify(res.data));

        sessionStorage.setItem('isLogin', '1');
        filterAddressParams(path);
      } else {
        $unifiedMessage({
          message: res.msg || '获取用户信息失败',
          position: 'center',
          duration: 0,
          type: 'error'
        });

        //直接进入后续流程路由
        _next();
      }
    })
    .catch(res => {
      $unifiedMessage({
        message: res.msg || '获取用户信息失败',
        position: 'center',
        duration: 0,
        type: 'error'
      });

      _next();
    });
}

/**
 * 初始化微信sdk, 包括分享设置
 * @param {*} initData
 * @param {*} shareData
 * @returns
 */
export function initWeChatSdk(initData = {}, shareData = {}) {
  const configParams = {
    debug: false,
    appId: initData.appId,
    timestamp: initData.timestamp,
    nonceStr: initData.nonceStr,
    signature: initData.signature,
    jsApiList: [
      'chooseWXPay',
      'updateAppMessageShareData',
      'updateTimelineShareData',
      'requestMerchantTransfer'
    ],
    openTagList: ['wx-open-subscribe', 'wx-open-launch-weapp'] // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
  };
  console.log('initWeChatSdk wxconfigParams:', JSON.stringify(configParams));

  return new Promise(resolve => {
    if (window['wx']) {
      wx.config(configParams);
      wx.ready(() => {
        console.log('---- wxshareData:', JSON.stringify(shareData));
        const link = shareData?.link || '';
        const linkArr = link.split('?');
        let friendLink = linkArr[0]; // 微信分享链接
        let friendZoneLink = linkArr[0]; // 微信朋友圈分享链接
        if (linkArr.length > 1) {
          const query = qs.parse(linkArr[1]);
          query.invite_way = 2;
          friendLink = `${friendLink}${qs.stringify(query, true)}`;

          query.invite_way = 3;
          friendZoneLink = `${friendZoneLink}${qs.stringify(query, true)}`;
        }
        console.log('-----wxshareData friendLink:', friendLink);
        console.log('-----wxshareData friendZoneLink:', friendZoneLink);

        // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0）最新接口
        wx.updateAppMessageShareData({
          title: shareData.title, // 分享标题
          desc: shareData.desc || '', // 分享描述
          // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          link: friendLink,
          imgUrl: shareData.imgUrl, // 分享图标
          success() {
            // 设置成功
            console.log('updateAppMessageShareData success');
            resolve({ action: 'updateAppMessageShareData', isSuccess: true });
          },
          fail: function (error) {
            // 设置失败
            console.log('updateAppMessageShareData error:', error);
          }
        });

        // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0）最新接口
        wx.updateTimelineShareData({
          title: shareData.title, // 分享标题
          desc: shareData.desc || '', // 分享描述
          link: friendZoneLink,
          imgUrl: shareData.imgUrl, // 分享图标
          success() {
            // 设置成功
            console.log('updateTimelineShareData success');
            resolve({ action: 'updateTimelineShareData', isSuccess: true });
          },
          fail: function (error) {
            // 设置失败
            console.log('updateTimelineShareData error:', error);
          }
        });

        wx.error(function (res) {
          console.error('获取微信信息失败1', res);
        });
      });
    } else {
      resolve();
    }
  });
}

/**
 * 初始化企业微信sdk, 包括分享设置
 * @param {*} initData
 * @param {*} shareData
 * @returns
 */
export function initWwChatSdk(initData = {}, shareData = {}) {
  return new Promise(resolve => {
    if (window['ww']) {
      console.log('-------start---');
      window['ww'].register({
        debug: true,
        beta: true,
        corpId: initData.corpId, //当前用户所属企业 ID
        jsApiList: [
          'onMenuShareAppMessage',
          'onMenuShareWechat',
          'onMenuShareTimeline',
          'requestMerchantTransfer'
        ],
        getConfigSignature() {
          console.log(initData);
          return initData;
        },
        onConfigSuccess(res) {
          console.log('onConfigSuccess-------', res);

          console.log('-----shareData:', JSON.stringify(shareData));
          const link = shareData?.link || '';
          const linkArr = link.split('?');
          let friendLink = linkArr[0]; // 微信分享链接
          let friendZoneLink = linkArr[0]; // 微信朋友圈分享链接
          if (linkArr.length > 1) {
            const query = qs.parse(linkArr[1]);
            query.invite_way = 2;
            friendLink = `${friendLink}${qs.stringify(query, true)}`;

            query.invite_way = 3;
            friendZoneLink = `${friendZoneLink}${qs.stringify(query, true)}`;
          }
          console.log('-----friendLink:', friendLink);
          console.log('-----friendZoneLink:', friendZoneLink);

          // 获取「转发」按钮点击状态并自定义分享内容。
          window['ww'].onMenuShareAppMessage({
            title: shareData.title, // 分享标题
            desc: shareData.desc || '', // 分享描述
            // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            link: friendLink,
            imgUrl: shareData.imgUrl, // 分享图标
            success() {
              // 设置成功
              resolve({ action: 'onMenuShareAppMessage', isSuccess: true });
            }
          });

          // 获取「微信」按钮点击状态并自定义分享内容。
          window['ww'].onMenuShareWechat({
            title: shareData.title, // 分享标题
            desc: shareData.desc || '', // 分享描述
            link: friendLink,
            imgUrl: shareData.imgUrl, // 分享图标
            success() {
              // 设置成功
              resolve({ action: 'onMenuShareWechat', isSuccess: true });
            }
          });

          // 获取「分享到朋友圈」按钮点击状态并自定义分享内容。
          window['ww'].onMenuShareTimeline({
            title: shareData.title, // 分享标题
            desc: shareData.desc || '', // 分享描述
            link: friendZoneLink,
            imgUrl: shareData.imgUrl, // 分享图标
            success() {
              // 设置成功
              resolve({ action: 'onMenuShareTimeline', isSuccess: true });
            }
          });
        },
        onConfigFail(res) {
          console.log('onConfigFail-------', res);
        },
        onConfigComplete(res) {
          console.log('onConfigComplete-------', res);
        }
      });
    } else {
      resolve();
    }
  });
}

/**
 * 隐藏微信菜单选项
 * @param {*} initData
 * @param {*} failedCb
 */
export function initHideChatSdk(initData = {}, failedCb = () => {}) {
  let hideConfigSdk = {
    debug: false,
    jsApiList: ['hideMenuItems', 'hideAllNonBaseMenuItem', 'showMenuItems'],
    appId: initData.appId,
    timestamp: initData.timestamp,
    nonceStr: initData.nonceStr,
    signature: initData.signature,
    openTagList: ['wx-open-subscribe', 'wx-open-launch-weapp'] // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
  };

  console.log('initWeChatSdk wxconfigParams:', JSON.stringify(hideConfigSdk));

  wx.config(hideConfigSdk);

  //微信初始化完成
  wx.ready(function () {
    wx.hideMenuItems({
      menuList: [
        'menuItem:share:appMessage',
        'menuItem:share:timeline',
        'menuItem:share:qq',
        'menuItem:share:weiboApp',
        'menuItem:share:facebook',
        'menuItem:share:QZone',
        'menuItem:copyUrl'
      ]
    });
  });

  //微信错误回调
  wx.error(function (res) {
    console.log('微信隐藏菜单配置错误------>', res);
    wx.hideAllNonBaseMenuItem();
    failedCb(res);
    //上报日志
    window.vhallLog({
      tag: 'wx', // 日志所属功能模块
      data: res,
      type: 'log' // log 日志埋点，event 业务数据埋点
    });
  });

  document.addEventListener('WeixinOpenTagsError', function (e) {
    // 无法使用开放标签的错误原因，需回退兼容。仅无法使用开放标签，JS-SDK其他功能不受影响
    console.error('WeixinOpenTagsError', e.detail.errMsg);
  });
}
/**
 * 隐藏企业微信菜单选项
 * @param {*} initData
 * @param {*} failedCb
 */
export function initHideWwChatSdk(initData = {}, failedCb = () => {}) {
  if (window['ww']) {
    window['ww'].register({
      corpId: initData.corpId, //当前用户所属企业 ID
      jsApiList: ['hideMenuItems'],
      getConfigSignature() {
        return initData;
      }
    });

    //隐藏右上角菜单。
    // window['ww'].hideOptionMenu();

    //微信初始化完成
    window['ww'].hideMenuItems({
      menuList: [
        'menuItem:share:appMessage',
        'menuItem:share:wechat',
        'menuItem:share:timeline',
        'menuItem:copyUrl',
        'menuItem:openWithSafari',
        'menuItem:share:email'
      ]
    });
  }
}

//微信授权相关需要判断
export function authWeixinAjax(to, address, _next, authorizer_type = 0, wechat_open) {
  const isEmbed = !!/embed/.test(to.path);
  //如果是微信
  if ((isWechat() || wechat_open) && !isEmbed) {
    const open_id = sessionStorage.getItem('open_id');
    if (!open_id) {
      // 请求授权接口
      let business_uid = sessionStorage.getItem('initGrayId') || '';
      // authorizer_type	否 授权类型 0:弹窗授权 1:静默授权 默认弹窗授权
      useUserServer()
        .authWeixinAjax({
          source: 'wab',
          jump_url: address,
          visitor_id: sessionStorage.getItem('visitorId'),
          authorizer_type,
          business_uid
        })
        .then(res => {
          if (res && res.code == 200) {
            console.log('wechat 当前authWeChat接口请求后地址结果为：', res.data.url);
            if (authorizer_type == 1) {
              //静默授权
              window.location.replace(res.data.url);
            } else {
              // 弹窗授权
              if (sessionStorage.getItem('open_id')) {
                window.location.replace(res.data.url);
              } else {
                if (!isWechat() && wechat_open) {
                  window.location.href = res.data.url;
                  return;
                }
                sessionStorage.setItem('weixin_auth_url', res.data.url);
                _next();
              }
            }
          } else {
            $unifiedMessage({
              message: res.msg || '微信回调失败，请重新扫码',
              position: 'center',
              duration: 0,
              type: 'error'
            });

            // 如果是路由执行
            if (_next) {
              _next();
            }
          }
        })
        .catch(res => {
          $unifiedMessage({
            message: res.msg || '微信回调失败，请重新扫码',
            position: 'center',
            duration: 0,
            type: 'error'
          });
        });
    }
  } else {
    if (_next) {
      _next();
    }
  }
}

// 删除cms传过来的微信授权的url参数
function filterUrlParams() {
  const path = window.location.href;
  const filterParams = ['token', 'wx_openId', 'wx_user_auth_key', 'source_sceneid'];
  return filterParams.reduce((preVal, curVal) => {
    return removeUrlParameter(preVal, curVal);
  }, path);
}

// init微信授权跳转逻辑
export async function wxAuthCheck(to, next) {
  let _next = next;
  const query = { ...to.query };

  // 检查并删除 ticket 参数
  if (query.ticket) {
    delete query.ticket;
  }

  // 获取地址的一些参数
  let { user_auth_key, purpose, open_id, nickname, head_img_url } = getUrlQueryParams([
    'user_auth_key',
    'purpose',
    'open_id',
    'nickname',
    'head_img_url'
    // 'visitor_id'
  ]);
  // 若当前地址栏包含user_auth_key 以及 purposer入参，表示当前需要执行第三方信息回调
  if (user_auth_key && purpose) {
    if ((purpose == 'login' || purpose == 'payAuth') && user_auth_key) {
      let arr = [saveAndSyncBothStorage('open_id', open_id)];
      // if (nickname) arr.push(saveAndSyncBothStorage('wx_nickname', nickname)); //微信授权后的用户昵称
      // if (head_img_url) arr.push(saveAndSyncBothStorage('wx_avatar', head_img_url)); // 微信授权后的用户头像
      await Promise.all(arr);
      sessionStorage.setItem('user_auth_key', user_auth_key);
      // unionid 不能为会话缓存
      localStorage.setItem('unionid', user_auth_key);
      if (nickname) localStorage.setItem('dep_wx_nickname', nickname); // 微信授权后的用户昵称
      if (head_img_url) localStorage.setItem('dep_wx_head_img_url', head_img_url); // 微信授权后的用户头像

      filterAddressParams(window.location.pathname); // 过滤参数并跳转，举例： '/v3/lives/watch/671680195'
    }
  } else {
    // 开启了强制登录，微信授权完成后，在这里执行登录逻辑
    if (!open_id) open_id = sessionStorage.getItem('open_id');
    if (
      isWechat() &&
      open_id &&
      !localStorage.getItem('token') &&
      sessionStorage.getItem('wechat_force_login')
    ) {
      // 微信登录
      const subjectId = window.sessionStorage.getItem('subjectId');
      const params = {
        way: 5, // 微信登录固定值：5
        source_id: subjectId ? subjectId : to.params.id,
        source_type: subjectId ? 1 : 0,
        wx_open_id: open_id,
        user_type: 2, // 用户类型有误1：B端用户，2：C端用户，3:三方账号，100：admin用户
        biz_id: process.env.VUE_APP_BIZ_ID || 2,
        biz_application_id: window.$hcl.app_id, //应用id
        nick_name: nickname || '', // 微信昵称
        avatar: head_img_url || '', // 微信头像
        business_uid: sessionStorage.getItem('initGrayId') || ''
      };
      if (sessionStorage.getItem('visitorId')) {
        params.visitor_id = sessionStorage.getItem('visitorId');
      }
      const [err, res] = await tojs(useUserServer().wechatLogin(params));
      console.log('wechatLogin err:', err);
      console.log('wechatLogin res:', res);
      if (err || !res || res.code != 200 || !res.data || !res.data.token) {
        // 登录失败
        sessionStorage.removeItem('open_id');
        /* prettier-ignore */ // 去掉地址栏部分参数但不刷新
        removeUrlParamsAndUpdate(['user_auth_key', 'open_id', 'purpose', 'nickname', 'head_img_url', 'visitor_id']);
        $unifiedMessage({
          message: err?.msg || res?.msg || '登录失败',
          position: 'top',
          duration: 15000,
          type: 'error'
        });
        // 继续走界面逻辑，返回 510023 错误码，重新回到微信强制登录界面。
        next();
      } else {
        // 登录成功
        sessionStorage.removeItem('wechat_force_login');
        useRoomBaseServer().state.isWechatForceLogin = false;
        await saveAndSyncBothStorage('token', res.data.token);
        /* prettier-ignore */ // 去掉地址栏部分参数并刷新页面
        removeUrlParamsAndUpdate(['user_auth_key', 'open_id', 'purpose', 'nickname', 'head_img_url', 'visitor_id'], { reload: true });
      }
      return;
    }

    // 若当前用户已登录过或微信授权过，直接进入界面。
    if (isWechat() && sessionStorage.getItem('open_id')) {
      if (localStorage.getItem('token') && !sessionStorage.getItem('token')) {
        await saveAndSyncBothStorage('token', localStorage.getItem('token'));
      }
      next();
      return;
    }
    // 观看页和嵌入页需要微信授权
    if (!/watch|subscribe|special\/detail/.test(to.path) || /embed/.test(to.path)) {
      // 不是 预约/观看/专题详情页 或者 嵌入情况， 直接进入
      next();
    } else {
      // 微信登录鉴权
      let roomBaseServer = useRoomBaseServer();
      if (!isWechat() && !Number(roomBaseServer.state.configList['watch.wechat_open'])) {
        next();
        return;
      }
      // 判断是否admin开启了微信授权开关 + 未开启微信强制登录(因为微信强制登录有自己的授权)
      // 业务场景：1、限制直播只能在微信环境中观看
      const forceWechaLogin = roomBaseServer.state.configList['force_wechat_login'];
      if (forceWechaLogin == 1) {
        if (!sessionStorage.getItem('open_id')) {
          await saveAndSyncBothStorage('token', '');
        }
      }
      // ui.hide_wechat 1：开启微信授权； 0：关闭微信授权
      if (Number(roomBaseServer.state.configList['ui.hide_wechat'] && forceWechaLogin != 1)) {
        let address = buildLoginAddress(to);
        let authorizer_type = 0;
        if (Object.hasOwnProperty.call(roomBaseServer.state.configList, 'authorizer_type')) {
          authorizer_type = roomBaseServer.state.configList['authorizer_type'];
        }
        authWeixinAjax(
          to,
          address,
          _next,
          authorizer_type,
          Number(roomBaseServer.state.configList['watch.wechat_open'])
        );
      } else {
        if (_next) {
          _next();
        }
      }
    }
  }
}

/**
 * 设置微信分享新
 * @param {*} customShareSetting 自定义的分享信息
 * @param {*} excludeHide 隐藏分享权限开启情况下，是否初始化微信jssdk隐藏微信分享本身相关的菜单
 */
export async function setWxShareInfo(customShareInfo, excludeHide = false) {
  // 是否微信浏览器
  const isWechatBrowser = isWechat();
  if (!isWechatBrowser) return;

  let shareSetting;
  try {
    // 获取微信分享相关的设置信息
    shareSetting = await _getShareRelatedSettingInfo();
    if (shareSetting) {
      const shareConfig = {
        title: shareSetting?.title,
        cover: shareSetting?.img_url,
        introduction: replaceHtml(shareSetting?.introduction || '', 42)
      };
      window.wxShareConfig = {
        zh: shareConfig,
        en: shareConfig
      };
      vhSiteBaseInfoHandle(useRoomBaseServer());
    }
  } catch (ex) {
    console.error('inviteCard 获取微信分享相关的设置信息失败:', ex);
  }

  shareSetting = Object.assign({}, shareSetting, customShareInfo);
  shareSetting.title = (shareSetting.title || '').substring(0, 30); // 标题最长30个字符
  shareSetting.img_url = shareSetting.img_url ?? DEFAULT_SHARE_IMAGE; // 图片
  shareSetting.introduction = replaceHtml(shareSetting.introduction || '', 42); // 简介

  console.log('-----shareSetting:', JSON.stringify(shareSetting));

  let wx_sign_url = location.href.split('#')[0];
  const { system } = getBrowserType();
  if (system == 'ios') {
    // 微信浏览器&&苹果设备, 取出记录的第一次访问的URL
    wx_sign_url = sessionStorage.getItem('firstUrl');
  }
  // 获取微信sdk初始化需要的参数
  const res = await useRoomBaseServer().wechatOaSdkSign({
    url: system == 'ios' ? decodeURIComponent(wx_sign_url) : wx_sign_url, // 验证签名需要,
    business_uid: sessionStorage.getItem('initGrayId')
  });
  if (res.code == 200 && res.data) {
    // 活动微信初始化需要参数
    const params = {
      appId: res.data.app_id || res.data.appId, // 公众号的唯一标识
      timestamp: res.data.timestamp, // 生成签名的时间戳
      nonceStr: res.data.nonce_str || res.data.nonceStr, // 生成签名的随机串
      signature: res.data.signature // 签名
    };

    console.log('useRoomBaseServer().wechatShare wechatOaSdkSign params:', params);
    const configList = useRoomBaseServer().state.configList;
    const hideShare = configList ? !configList['ui.watch_hide_share'] : 0;
    if (hideShare == 1) {
      if (!excludeHide) {
        // 隐藏分享功能情况下，wechatsdk初始化
        initHideChatSdk({ ...params });
      }
    } else {
      // 正常情况下，wechatsdk初始化
      console.log('-----wxshare 正常情况下，wechatsdk初始化');
      console.log('-----wxshare shareSetting:', JSON.stringify(shareSetting));
      const searchParams = qs.parse(location.search); //没有得到的是{}
      Object.assign(searchParams, shareSetting.query); //合并参数

      // 创建分享链接
      const link = `${wx_sign_url.split('?')[0]}${qs.stringify(searchParams, true)}`;
      console.log('-----wxshare link:', link);
      initWeChatSdk(
        { ...params },
        {
          title: shareSetting.title,
          desc: shareSetting.introduction,
          link: link,
          imgUrl: shareSetting.img_url
        }
      );
    }
  } else {
    console.log('-----获取微信初始化信息失败:', res);
  }
}

/**
 * 设置企业微信分享
 * @param {*} customShareSetting 自定义的分享信息
 * @param {*} excludeHide 是否处理隐藏分享
 */
export async function setWWShareInfo(customShareInfo, excludeHide = false) {
  // 是否微信浏览器
  const isWechatComBrowser = isWechatCom();
  if (!isWechatComBrowser) return;

  let shareSetting;
  try {
    // 获取服务端设置的分享信息
    shareSetting = await _getShareRelatedSettingInfo();
    if (shareSetting) {
      const shareConfig = {
        title: shareSetting?.title,
        cover: shareSetting?.img_url,
        introduction: replaceHtml(shareSetting?.introduction || '', 42)
      };
      window.wxShareConfig = {
        zh: shareConfig,
        en: shareConfig
      };
      vhSiteBaseInfoHandle(useRoomBaseServer());
    }
  } catch {
    console.error('获取服务端设置的分享信息失败');
  }

  shareSetting = Object.assign({}, shareSetting, customShareInfo);
  shareSetting.title = (shareSetting.title || '').substring(0, 30); // 标题最长30个字符
  shareSetting.img_url = shareSetting.img_url ?? DEFAULT_SHARE_IMAGE; // 图片
  shareSetting.introduction = replaceHtml(shareSetting.introduction || '', 42); // 简介

  console.log('-----shareSetting:', JSON.stringify(shareSetting));

  let wx_sign_url = location.href.split('#')[0];
  const { system } = getBrowserType();
  if (system == 'ios') {
    // 微信浏览器&&苹果设备, 取出记录的第一次访问的URL
    wx_sign_url = sessionStorage.getItem('firstUrl');
  }
  // 获取微信sdk初始化需要的参数
  const res = await useRoomBaseServer().wwchatShare({
    url: wx_sign_url // 验证签名需要
  });
  if (res.code == 200 && res.data) {
    // 活动微信初始化需要参数
    const params = {
      corpId: res.data.cropid, // 企微的唯一标识
      timestamp: res.data.timestamp, // 生成签名的时间戳
      nonceStr: res.data.noncestr, // 生成签名的随机串
      signature: res.data.signature // 签名
    };
    const configList = useRoomBaseServer().state.configList;
    const hideShare = configList ? !configList['ui.watch_hide_share'] : 0;
    if (hideShare == 1) {
      if (!excludeHide) {
        // 隐藏分享功能情况下，wwchatsdk初始化
        initHideWwChatSdk({ ...params });
      }
    } else {
      // 正常情况下，wwchatsdk初始化
      console.log('-----正常情况下，wwchatsdk初始化');
      console.log('-----shareSetting:', JSON.stringify(shareSetting));
      const searchParams = qs.parse(location.search); //没有得到的是{}
      Object.assign(searchParams, shareSetting.query); //合并参数
      // 创建分享链接
      const link = `${wx_sign_url.split('?')[0]}${qs.stringify(searchParams, true)}`;
      console.log('-----link:', link);
      initWwChatSdk(
        { ...params },
        {
          title: shareSetting.title,
          desc: shareSetting.introduction,
          link: link,
          imgUrl: shareSetting.img_url
        }
      );
    }
  } else {
    console.log('-----获取企业微信初始化信息失败:', res);
  }
}

// 获取微信分享相关的设置信息
async function _getShareRelatedSettingInfo() {
  const roomBaseServer = useRoomBaseServer();
  const promiseList = [
    // 获取微信分享设置基本设置信息
    roomBaseServer.getShareSettingInfo()
  ];

  const inviteServer = useInviteServer();
  if (roomBaseServer.state.inviteCard?.status == 1 && !inviteServer.state.invite_code) {
    // 如果邀请卡开关开启了，且邀请码没有，则需要去获取，获取成功后，会把invite_code赋值给inviteServer.state.invite_code
    promiseList.push(fetchInviteCode());
  }
  // 这里不需要 .catch，因为 Promise.allSettled 永远不会 reject
  const results = await Promise.allSettled(promiseList);
  let shareSetting;
  if (results[0].status === 'fulfilled' && results[0].value && results[0].value.code == 200) {
    shareSetting = results[0].value.data;

    if (inviteServer.state.invite_code) {
      shareSetting.query = {
        invite_code: inviteServer.state.invite_code
      };
    }
  }
  return shareSetting;
}
